export const MAP = '__GMAP_MAP';
export const GOOGLE = '__GMAP_GOOGLE';
